exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wp-10[data-v-4ec5c82f]{\n  width: 10% !important;\n}\n.middle[data-v-4ec5c82f]{\n  vertical-align: middle;\n  margin: 0;\n}\n", ""]);

// exports
